import type { AttributeReviewDraftSelection } from "@/hooks/useAttributeReview.types";

type Pool = { key: string } & Record<string, unknown>;
type Offer = {
  kind: string;
  leaf: string;
  pool: Pool | null;
  values: unknown[];
};
type Item = {
  kind?: string | null;
  leaf?: string | null;
  pool?: Pool | null;
  values?: unknown[] | null;
  poolOffers?: Offer[] | null;
};

function offerFor(
  item: Item,
  draft: AttributeReviewDraftSelection,
): Offer | undefined {
  const kind = draft.kind ?? item.kind;
  const leaf = draft.leaf ?? item.leaf;
  return (item.poolOffers ?? []).find(
    (o) => o.kind === kind && o.leaf === leaf,
  );
}

export function shownAnswer(
  item: Item,
  draft: AttributeReviewDraftSelection | undefined,
) {
  if (!draft?.kind && !draft?.leaf && !draft?.pool)
    return { pool: item.pool ?? null, values: item.values ?? [] };
  const offer = offerFor(item, draft);
  if (offer && (!draft.pool || offer.pool?.key === draft.pool)) {
    return { pool: offer.pool, values: offer.values };
  }
  const sameLeaf = (draft.leaf ?? item.leaf) === item.leaf;
  const sameKind = (draft.kind ?? item.kind) === item.kind;
  if (sameLeaf && sameKind && (!draft.pool || draft.pool === item.pool?.key)) {
    return { pool: item.pool ?? null, values: item.values ?? [] };
  }
  return { pool: null, values: [] };
}

export function draftAfterPoolReply(
  draft: AttributeReviewDraftSelection,
  item: Item,
  keepFixes = false,
): AttributeReviewDraftSelection {
  const { values: _dropped, ...rest } = draft;
  const base = keepFixes ? draft : rest;
  const key = offerFor(item, draft)?.pool?.key;
  return key ? { ...base, pool: key } : base;
}
